const IconStar = ({ size, color, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 44 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            className="star-fill"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.5264 15.756C27.086 15.756 26.6975 15.4679 26.5696 15.0466L22.9568 3.1507C22.6696 2.20482 21.3304 2.20482 21.0432 3.1507L17.4304 15.0466C17.3025 15.4679 16.914 15.756 16.4736 15.756H3.91536C2.96312 15.756 2.5498 16.961 3.30156 17.5455L13.5763 25.534C13.9032 25.7882 14.0396 26.2176 13.9194 26.6139L10.1641 38.9878C9.88087 39.9212 10.9649 40.6664 11.7349 40.0676L21.3861 32.5624C21.7472 32.2816 22.2528 32.2816 22.6139 32.5624L32.2651 40.0676C33.0351 40.6664 34.1191 39.9212 33.8359 38.9878L30.0807 26.6139C29.9604 26.2176 30.0968 25.7882 30.4238 25.534L40.6984 17.5455C41.4502 16.961 41.0369 15.756 40.0846 15.756H27.5264Z"
            fill={color || '#FF6B00'}
        />

        <path
            className="star-outline"
            d="M27.5264 14.756L23.9137 2.86011C23.3392 0.96835 20.6608 0.968345 20.0863 2.86011L16.4736 14.756L3.91536 14.756C2.01088 14.756 1.18424 17.1659 2.68776 18.3349L12.9624 26.3235L9.20723 38.6974C8.6407 40.5642 10.8088 42.0546 12.3488 40.857L22 33.3518L31.6512 40.857C33.1912 42.0546 35.3593 40.5642 34.7928 38.6974L31.0376 26.3235L41.3122 18.3349C42.8158 17.1659 41.9891 14.756 40.0846 14.756H27.5264Z"
            stroke={color || '#343132'}
            strokeOpacity="0.3"
            strokeWidth="2"
        />
    </svg>
);

export default IconStar;
